"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var TOGGLE_EVENT = 'toggle';
var _default2 = {
  model: {
    prop: 'visible',
    event: TOGGLE_EVENT
  },
  props: {
    visible: {
      type: Boolean,
      "default": false
    },
    mask: {
      type: Boolean,
      "default": true
    },
    maskClosable: {
      type: Boolean,
      "default": false
    },
    maskCls: {
      type: String,
      "default": ''
    },
    wrapCls: {
      type: String,
      "default": ''
    },
    getRenderContainer: {
      type: [Function, String],
      "default": function _default() {
        return document.body;
      }
    }
  }
};
exports["default"] = _default2;